<template>
  <b-row>
      <b-col class="box col-md-6 col-lg-3" v-for="(menu, idx) in menus" :key="idx">
        <div v-if="menu.children">
          <h5 >
              <i :class="menu.icon"></i>
              {{menu.title}}
          </h5>
          <ul>
              <li class="sub-link" v-for="(child, idx) in menu.children" :key="idx">
                  <router-link :to="{path:child.url}" v-if="!child.children">
                      <i :class="child.icon"></i>
                      {{child.title}}
                      <span v-if="child.badge" class="badge badge-pill badge-danger">{{child.badge.text}}</span>    
                  </router-link>
                  
                  <div v-if="child.children">
                      <label>
                          <i :class="child.icon"></i>
                          {{child.title}}
                      </label>
                      <ul>
                          <li v-for="(child1, idx) in child.children" :key="idx">
                              <router-link :to="{path:child1.url}">
                                  <i :class="child1.icon"></i>
                                  {{child1.title}}
                                <span v-if="child1.badge" class="badge badge-pill badge-danger">{{child1.badge.text}}</span>    
                              </router-link>
                          </li>
                      </ul>
                  </div>
              </li>
          </ul>          
        </div> 
        <div v-else>
            <router-link :to="{path:menu.url}" >
                <i :class="menu.icon"></i>
                {{menu.title}}
                <span v-if="menu.badge" class="badge badge-pill badge-danger">{{menu.badge.text}}</span>    
            </router-link>
        </div>
      </b-col>
  </b-row>
</template>

<style lang="scss" scoped>
h5 {
  i {
    margin-right: 5px;
  }
}

ul {
  padding-left: 0;

  .sub-link {
    display: block;
    margin-left: 10px;
    font-size: smaller;
    i {
      width: 20px;
    }

    li {
      display: block;
      padding-left: 20px;

      i {
        width: 15px;
      }
    }
  }
}
</style>


<script>
export default {
  props: ["menus"],
  methods: {
    closeLink(item) {
      console.log("---, close link", item);
      const { $router } = this;
      $router.push(item.url);
    }
  }
};
</script>
